function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M37 0H17v46H0l27 24 27-24H37V0z",
  fill: "url(#pcArrow_svg__paint0_linear_4088_17193)"
});

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "pcArrow_svg__paint0_linear_4088_17193",
  x1: 27,
  y1: -2,
  x2: 27,
  y2: 70,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5445FF",
  stopOpacity: 0.01
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#6270FF",
  stopOpacity: 0.4
})));

function SvgPcArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 70,
    viewBox: "0 0 54 70",
    fill: "none"
  }, props), _ref, _ref2);
}

export default SvgPcArrow;